import { useCallback } from 'react';
import { canUseFeatureByTier } from '../services/tiers-service';
import { useMondayContext } from '../contexts/monday-context';

const isProduction = process.env.REACT_APP_ENV === 'production';

const ACCOUNT_ID_WHITELIST = [5];
const USER_ID_WHITELIST = [
  14077801, // Nadav
  14679772, // Vitali
  14174097, // Nave
  20573092, // Tomer
  13988274, // Ron
];

export default function useFeatures() {
  const { userData = {}, grantedFeatures = {} } = useMondayContext();
  const grantedFeaturesData = grantedFeatures ? grantedFeatures : {};
  const { id: userId, accountId } = userData;

  const canFeature = useCallback(
    (featureName) => {
      if (!isProduction) return true;

      if (featureName && !!grantedFeaturesData[featureName]) return true;

      if (!userId || !accountId) return false;

      return USER_ID_WHITELIST.includes(parseInt(userId)) && ACCOUNT_ID_WHITELIST.includes(parseInt(accountId));
    },
    [userId, accountId, grantedFeaturesData]
  );


  const canFeatureByTierOrGranted = useCallback(
    (featureName, tier) => {
      const canFeatureByTier = canUseFeatureByTier(featureName, tier);
      const canByGrantedFeature = canFeature(featureName);

      return canFeatureByTier || canByGrantedFeature;
    },
    [canFeature]
  );

  return { canFeature, grantedFeatures, canFeatureByTierOrGranted };
}
